import { render, staticRenderFns } from "./Template45.vue?vue&type=template&id=4c629ccc&scoped=true&"
import script from "./Template45.vue?vue&type=script&lang=js&"
export * from "./Template45.vue?vue&type=script&lang=js&"
import style0 from "./Template45.vue?vue&type=style&index=0&id=4c629ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c629ccc",
  null
  
)

export default component.exports